import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  tags: [],
  cardPrice: 0,
  location: null,
};

const commonSlice = createSlice({
  name: "commonSlice",
  initialState,
  reducers: {
    saveTags(state, action) {
      state.tags = action.payload;
    },
    saveCardPrice(state, action) {
      state.cardPrice = action.payload;
    },
    saveLocation(state, action) {
      state.location = action.payload;
    },
  },
});

export const { saveTags, saveCardPrice, saveLocation } = commonSlice.actions;

export default commonSlice.reducer;
